import { createRouter, createWebHashHistory } from "vue-router";
import UsedTrackingIndex from "../pages/General/TrackingIndex.vue";
import UsedAuthLoginIndex from "../pages/Account/AuthIndex.vue";
import UsedReimbursementIndex from "../pages/Account/ReimbursementIndex.vue";
import UsedDashboardIndex from "../pages/Account/DashboardIndex.vue";
import UsedPaymentRequestndex from "../pages/Account/PaymentRequest.vue";
import UsedTrackingDetailIndex from "../pages/General/TrackingDetails.vue";
import UsedTemporaryDataFiles from "../pages/General/TemporaryDataFile.vue";
import UsedDeclinedIndex from "../pages/General/DeclinedLetter.vue";
import axios from "@/utils/axios";
import store from "../store";

const routes = [
  {
    path: "/",
    name: "Onboarding",
    component: UsedTrackingIndex,
    meta: {
      title: "Tracking",
      layout: "General",
      requiresAuth: false,
    },
  },
  {
    path: "/admin/login",
    name: "Login",
    component: UsedAuthLoginIndex,
    meta: {
      title: "Login",
      layout: "General",
      requiresAuth: false,
    },
  },
  {
    path: "/admin/dashboard",
    name: "Dashboard",
    component: UsedDashboardIndex,
    meta: {
      title: "Dashboard",
      layout: "Account",
      requiresAuth: true,
    },
  },
  {
    path: "/admin/reimbursement",
    name: "Reimbursement",
    component: UsedReimbursementIndex,
    meta: {
      title: "Reimbursement",
      layout: "Account",
      requiresAuth: true,
    },
  },
  {
    path: "/admin/payment",
    name: "PaymentRequest",
    component: UsedPaymentRequestndex,
    meta: {
      title: "Payment Request",
      layout: "Account",
      requiresAuth: true,
    },
  },
  {
    path: "/tracking/:id",
    name: "TrackingNumber",
    component: UsedTrackingDetailIndex,
    meta: {
      title: "Tracking Details",
      layout: "General",
      requiresAuth: false,
    },
  },
   {
    path: "/temporary/meta/x/file/:id(.*)",
    name: "Temporary",
    component: UsedTemporaryDataFiles,
    meta: {
      title: "test",
      layout: "General",
      requiresAuth: false,
    },
  },
   {
    path: "/temporary/meta/x/decline/:id(.*)",
    name: "Declined",
    component: UsedDeclinedIndex,
    meta: {
      title: "test",
      layout: "General",
      requiresAuth: false,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  document.title = `REIMBURSEMENT TRACKING`;
  let isAuthenticate;
  try {
    let { data } = await axios.get(`/authorization`);
    isAuthenticate = data.authorized;
    store.commit("authorizedHandler", isAuthenticate);
  } catch (error) {
    console.log(error);
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticate) {
      next({ path: "/" });
    } else {
      next();
    }
  } else {
    if (to.name === "Login" && isAuthenticate) {
      next({ path: "/admin/dashboard" });
    } else {
      next();
    }
  }
});

export default router;
